import * as React from 'react';
import { forwardRef } from 'react';

import { FieldFormGroupProps, FieldFormGroup } from '@shared/components/fields/field_form_group';

export type SelectFormGroupType = HTMLSelectElement;
export type SelectFormGroupProps = React.SelectHTMLAttributes<HTMLSelectElement> & FieldFormGroupProps;

export const SelectFormGroup = forwardRef<SelectFormGroupType, SelectFormGroupProps>(
  ({ has, help, label, className, ...input }, ref) => (
    <FieldFormGroup has={has} help={help} label={label} className={className} id={input.id}>
      <select className="form-control" ref={ref} {...input} />
    </FieldFormGroup>
  ),
);
